// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a34cea14","879":"50eb3519"}[chunkId] + ".chunk.js";
};